import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {lastValueFrom} from "rxjs";
import {PerFormaAPIService, ProfileResponse} from "src/app/services/pfapi.service";

@Component({
    selector: "app-user-info",
    templateUrl: "./user-info.component.html",
    styleUrls: ["./user-info.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserInfoComponent implements OnInit {
    user: ProfileResponse | null = null;
    loading = true;

    constructor(private readonly api: PerFormaAPIService) {}
    async ngOnInit() {
        try {
            this.user = await lastValueFrom(this.api.getApiProfile());
        } finally {
            this.loading = false;
        }
    }
}
